import { render, staticRenderFns } from "./product-groups.vue?vue&type=template&id=4f63fde6&scoped=true"
import script from "./product-groups.vue?vue&type=script&lang=js"
export * from "./product-groups.vue?vue&type=script&lang=js"
import style0 from "./product-groups.vue?vue&type=style&index=0&id=4f63fde6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63fde6",
  null
  
)

export default component.exports